import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
// import { useStore } from '@mcn-platform/models';
import { useStore } from '@mcn-platform/models';
import PlaceHolder from '../common/PlaceHolder';
import ItemContent from '../class/lessonPanel/ItemContent';
const AssetWidget = ({ assetKey, editData, }) => {
    const [asset, setAsset] = useState();
    const { currentOrganization, getOrLoad } = useStore();
    console.log('AssetWidget', { assetKey, editData, currentOrganization });
    useEffect(() => {
        const loadData = async () => {
            setAsset(getOrLoad('asset', assetKey));
        };
        loadData();
    }, [assetKey, getOrLoad]);
    const isEmpty = () => (!assetKey);
    if (editData && isEmpty()) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure Asset" }));
    }
    if (!asset || asset.syncState !== 'loaded') {
        return _jsx("div", { children: "..." });
    }
    if (!assetKey) {
        console.log('AssetWidget: assetKey is not defined');
        return null;
    }
    const section = {
        type: asset.type,
        item: {
            headline: asset.description,
            asset,
        },
    };
    return (_jsx(ItemContent, { section: section, showPlayerControls: true, seekPosition: undefined, onProgress: () => { }, onEnd: () => { }, handleNextPrevious: () => { } }));
};
AssetWidget.meta = {
    group: 'portal',
    name: 'Asset',
    description: 'Display a asset.',
    props: [
        {
            key: 'assetKey',
            name: 'Asset',
            type: 'asset',
            description: 'Asset to display.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'AssetWidget',
        props: {
            assetKey: '@assetKey',
            layout: {
                padding: {
                    top: 8,
                    left: 8,
                    right: 8,
                    bottom: 8,
                },
            },
        },
    },
};
export default observer(AssetWidget);
//# sourceMappingURL=AssetWidget.js.map